import React, { useMemo } from "react";
import { ThemeProvider, useTheme } from "@material-ui/core/styles";
import createTicketsTheme, { createTicketsMuiTheme } from "../../theme/ticketsTheme";
import { ThemeProvider as MuiThemeProvider, useTheme as useMuiTheme } from "@mui/material/styles";
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import Tickets from "../TicketsCustom"
import TicketAdvanced from "../TicketsAdvanced";

function TicketResponsiveContainer (props) {
    const baseTheme = useTheme();
    const baseMuiTheme = useMuiTheme();
    const ticketsTheme = useMemo(() => createTicketsTheme(baseTheme), [baseTheme]);
    const muiTheme = useMemo(() => createTicketsMuiTheme(baseTheme), [baseTheme]);
    const content = isWidthUp('md', props.width) ? <Tickets /> : <TicketAdvanced />;
    return <ThemeProvider theme={ticketsTheme}>
        <MuiThemeProvider theme={ticketsTheme.ticketDark || baseTheme.uiPalette === "github" ? muiTheme : baseMuiTheme}>{content}</MuiThemeProvider>
    </ThemeProvider>;
}

export default withWidth()(TicketResponsiveContainer);
